import { Side } from "@radix-ui/popper";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import { classNames } from "./utils/classNames";

interface Props {
  children: React.ReactNode;
  content: React.ReactNode;
  side?: Side;
  delayDuration?: number;
  arrowOffset?: number;
  sideOffset?: number;
}

const Tooltip = (props: Props) => {
  return (
    <RadixTooltip.Root delayDuration={props.delayDuration}>
      <RadixTooltip.Trigger asChild>{props.children}</RadixTooltip.Trigger>
      <RadixTooltip.Content
        side={props.side}
        sideOffset={props.sideOffset ?? 2}
        className={classNames(
          "pointer-events-none break-words rounded bg-white px-16 py-12 text-14-16 leading-4 text-gray-800 shadow-c",
          props.side === "top" && "animate-fade-in-down",
          props.side === "bottom" && "animate-fade-in-up"
        )}
      >
        <RadixTooltip.Arrow
          offset={props.arrowOffset}
          className="fill-white shadow-c"
        />
        {props.content}
      </RadixTooltip.Content>
    </RadixTooltip.Root>
  );
};

export default Tooltip;
